import React from 'react'
import { ICONO_CATALOGOS } from '../../utils/constants'




// las imagenes pueden ser combinaciones de las imagenes, puetas en array de una constante
const Card = ({ data, handleClick, textoBoton, id, value }) => {




  return (

    <div className={"bg-primarioMira rounded-md m-2 content-center"}>
      {/*
      <h2 className=" |mx-auto text-lg font-medium text-white">Cursos disponibles</h2>
      */}
      <div className={"grid content-center mt-2"}>
        <p className={"text-white mx-auto font-medium text-2xl"}>Cursos disponibles</p>
      </div>
      <div role="list" className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 mx-3 mb-4">

        {data && data.map((project, index) => (
          <div key={index} className=" max-w-sm p-2 xl:p-6 border border-gray-200 bg-secundarioMira rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 text-center elementFadeIn" >
            <div className='flex flex-row'>
              {
                ICONO_CATALOGOS[project?.IdCatalogo].map((element, index) => (
                  <img
                    // width="full" 
                    // height="14"
                    className="w-[20%] mx-auto rounded"
                    src={`./img/cursos/${ICONO_CATALOGOS[project?.IdCatalogo][index]}`}
                    alt="visual-studio-code-2019" />
                ))
              }
            </div>

            <a href="#">
              <h5 className="mb-2 text-md xl:text-2xl xl:font-medium tracking-tight text-white dark:text-white">{project[value]}</h5>
            </a>

            <a href="#" className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-azulBrillanteMira rounded-lg hover:bg-secundario hover:shadow-white shadow-sm "
              onClick={() => handleClick(project[id])}
            >
              {textoBoton}
              <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
              </svg>
            </a>
          </div>
        ))}
      </div>

    </div>

  )
}

export default Card